module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_02.240bd304.png";